import React from "react";
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Paper } from '@mui/material';

// EventSchedule Component
const EventSchedule = () => {
  // Sort events by event.startDateTime
  const sortedEvents = [...events].sort((a, b) => new Date(a.startDateTime) - new Date(b.startDateTime));

  return (
    <div className="p-4 bg-white" style={{ maxWidth: '1200px', margin: 'auto' }}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {sortedEvents.map((event, index) => (
          <Paper elevation={3} key={index} className="p-4">
            <div className="flex flex-col gap-2">
              <div className="text-lg md:text-2xl font-semibold">{event.title}</div>
              <div className="flex items-center text-lg">
                <EventAvailableIcon sx={{ width: "30px", color: "deepSkyBlue" }} />
                <span>{event.date}</span>
              </div>
              {event.location && (
                <div className="flex items-center">
                  <LocationOnIcon sx={{ width: "30px", color: "coral" }} />
                  <span>{event.location}</span>
                </div>
              )}
              {event.description && (
                <div
                  className="text-md"
                  dangerouslySetInnerHTML={{ __html: event.description }}
                />
              )}
            </div>
          </Paper>
        ))}
      </div>
    </div>
  );
};

// Events with startDateTime for sorting
const events = [
  {
    title: "Registration (Day 1)",
    date: "12:00 – 17:00, 29 September 2025",
    startDateTime: "2025-09-29T12:00:00",
    location: "Foyer of Building 6 (SMART), University of Wollongong main campus",
    description: ""
  },
  {
    title: "Pre-conference Technical Workshop",
    date: "14:30 – 16:30, 29 September 2025",
    startDateTime: "2025-09-29T14:30:00",
    location: "Room 105, Building 6 (SMART), University of Wollongong main campus",
    description: `<strong>1.</strong> Vertical shaft hoisting safety equipment & wire rope replacement technology – Han Jia, Sansen Well (Shanghai) Robotics Co., Ltd, China<br /><strong>2.</strong> AI and IoT based electronic and photonic sensing technologies for mining safety and health applications – Associate Professor Enbang Li, University of Wollongong`
  },
  {
    title: "Conference Welcome Reception",
    date: "17:00 – 19:00, 30 September 2025",
    startDateTime: "2025-09-30T17:00:00",
    location: "The Deck, Novotel Hotel Wollongong Northbeach",
    description: ""
  },
  {
    title: "Registration (Day 2–4)",
    date: "8:15 – 12:00, 30 September – 2 October 2025",
    startDateTime: "2025-09-30T08:15:00",
    location: "Illawarra Gallery, Novotel Hotel Wollongong Northbeach",
    description: ""
  },
  {
    title: "Conference Banquet",
    date: "19:00 – 22:30, 1 October 2025",
    startDateTime: "2025-10-01T19:00:00",
    location: "Hoskins and McCabe Room, Novotel Hotel Wollongong Northbeach",
    description: ""
  },
  {
    title: "Post-conference Industry Visit: Bisalloy Steels",
    date: "9:00 – 10:30, 3 October 2025",
    startDateTime: "2025-10-03T09:00:00",
    location: "Departing from bus stop, Aquatic Centre, University of Wollongong",
    description: ""
  },
  {
    title: "Post-conference Industry Visit: Coal Services",
    date: "Afternoon of 3 October 2025",
    startDateTime: "2025-10-03T13:30:00",
    location: "Departing from bus stop, Aquatic Centre, University of Wollongong",
    description: ""
  }
];

export default EventSchedule;